import React from 'react';
import {Filter, TextInput, BooleanInput, ReferenceArrayInput,SelectArrayInput} from 'react-admin';

import { makeStyles, Chip } from '@material-ui/core';

const useQuickFilterStyles = makeStyles(theme => ({
        chip: {
                marginBottom: theme.spacing(1),
        },
}));
const QuickFilter = ({ label }) => {
        const classes = useQuickFilterStyles();
        return <Chip className={classes.chip} label={label} />;
};

export const MovieFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />

        {/*<QuickFilter source="is_enabled" defaultValue={true} label={"Enabled"}  />*/}
        <QuickFilter source="is_disabled" defaultValue={true} label={"Disabled"}  />
        <QuickFilter source="is_featured"  defaultValue={true}  label={"Featured"} />
        <QuickFilter source="lackOfData" defaultValue={true} label={'Lack of Metadata'}  />
        <QuickFilter source="noPoster" defaultValue={true} label={'No Poster'}  />
        <QuickFilter label="Archived"   source="deleted" defaultValue={true} />

        <ReferenceArrayInput reference="genre" source="genres" label="Genres" allowEmpty>
            <SelectArrayInput optionValue="slug"></SelectArrayInput>
        </ReferenceArrayInput>
    </Filter>
);
